import {computed, inject, Injectable} from '@angular/core';
import {RegionService} from '../../service/region/region.service';
import {toSignal} from '@angular/core/rxjs-interop';
import {Region} from './region.interface';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RegionStore {
  private regionService = inject(RegionService);

  private rawRegions = toSignal<Region[] | null>(this.regionService.getRegions().pipe(
    catchError(() => of(null)),),
    { initialValue: null });

  readonly region = computed(() => {
    const data = this.rawRegions();
    if (!data) return [];
    return data.map(item => ({
      name: item.name,
      value: item.name,
    }));
  });
}

